import React from 'react';
import { BookOpenIcon, CreditCardIcon, DownloadIcon, LockKeyholeIcon, ShieldCheckIcon, StarIcon, ZapIcon } from 'lucide-react';
import { motion, useReducedMotion } from 'framer-motion';
import { CTAButton, Section } from './Shared';
import { PRICE, PRICE_FULL } from '../data/pack';
const benefits = [{
  icon: BookOpenIcon,
  label: 'Listo para imprimir o usar en tablet'
}, {
  icon: LockKeyholeIcon,
  label: 'Pago seguro'
}, {
  icon: CreditCardIcon,
  label: 'Mercado Pago'
}, {
  icon: DownloadIcon,
  label: '100% PDF'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}];
export function Pricing() {
  const reduceMotion = useReducedMotion();
  return <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-202" data-mp="20sd473b044fc">
      <Section id="pricing" glow className="astral-canvas my-12 rounded-[2rem] border border-brand-gold/45 bg-brand-paper/70 shadow-[0_20px_58px_rgba(36,28,60,0.1)]" data-id="element-203" data-mp="3h6v6lsn3r4iy">
        <div className="mx-auto max-w-2xl text-center" data-id="element-204" data-mp="3vzym6f0q9521">
          <span className="inline-flex items-center gap-2 rounded-full bg-brand-teal px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.14em] text-brand-deep" data-id="element-205" data-mp="3vz6xzp9gm9ls">
            <StarIcon className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-206" data-mp="9ta5dc9yqkt0" />
            Oferta de lanzamiento
          </span>
          <h2 className="mt-5 font-display text-2xl font-bold text-brand-ink md:text-4xl" data-id="element-207" data-mp="eqk0n8k19qor">
            TU <span className="text-brand-violet" data-id="element-208" data-mp="3dasc1ge01lru">ATLAS DE GEOMETRÍA SAGRADA</span>
          </h2>
          <p className="mt-3 text-sm text-brand-muted md:text-base" data-id="element-209" data-mp="3i8k54dqdrdxm">
            El precio de lanzamiento cierra pronto. Después sube $25.000 ARS.
          </p>
        </div>

        <div className="mx-auto mt-9 max-w-2xl" data-id="element-210" data-mp="3rywuqkd1xxam">
          <div className="rounded-3xl border-2 border-brand-gold/70 bg-brand-paper p-5 shadow-[0_16px_44px_rgba(8,4,20,0.5)] md:p-7" data-id="element-211" data-mp="3rzojbb88eure">
            <div className="flex items-center gap-2 text-brand-goldDark" data-id="element-212" data-mp="2zgr9scnu9gmq">
              <StarIcon className="h-3.5 w-3.5 shrink-0 fill-current" aria-hidden="true" data-id="element-213" data-mp="2rguxx8i4nmb3" />
              <span className="text-[10px] font-bold uppercase tracking-[0.16em] md:text-xs" data-id="element-214" data-mp="2mhrufshspo58">
                El sistema visual más completo de geometría sagrada aplicada en
                español
              </span>
            </div>
            <div className="mt-4 flex flex-col justify-between gap-5 sm:flex-row sm:items-end" data-id="element-215" data-mp="2w7beh1h8vo1o">
              <div data-id="element-216" data-mp="28h7csznm9ydb">
                <h3 className="font-display text-base font-bold leading-tight text-brand-ink md:text-lg" data-id="element-217" data-mp="28is6yo60rfan">
                  ATLAS DE GEOMETRÍA SAGRADA APLICADA AL CUERPO™
                </h3>
                <p className="mt-1 text-sm text-brand-muted" data-id="element-218" data-mp="2igy6iz4cs9cc">
                  3 Tomos + 6 Bonos · 150 páginas + material completo
                </p>
                <p className="mt-3 max-w-lg text-sm font-medium leading-relaxed text-brand-teal" data-id="element-219" data-mp="3tvbqvtzwe6nm">
                  El pack visual definitivo para terapeutas que quieren
                  perfeccionar su práctica, reducir la improvisación y aplicar
                  con la precisión que sus pacientes merecen.
                </p>
              </div>
              <div className="shrink-0 text-left sm:text-right" data-id="element-220" data-mp="5a9nel87lcwg">
                <p className="text-sm text-brand-muted line-through" data-id="element-221" data-mp="3nflc0goszsh1">
                  {PRICE_FULL}
                </p>
                <p className="font-display text-2xl font-bold text-brand-violet md:text-3xl" data-id="element-222" data-mp="3rhq3b8rs4d0i">
                  {PRICE}
                </p>
              </div>
            </div>
          </div>
          <motion.div animate={reduceMotion ? undefined : {
          y: [0, -2, 0]
        }} transition={{
          duration: 2.8,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="mt-6" data-id="element-223" data-mp="o07xt7zhbi39">
            <CTAButton fullWidth className="py-5 md:text-xl" data-id="element-224" data-mp="16qftx64rh89y">
              → QUIERO MI ATLAS DE GEOMETRÍA $27.990
            </CTAButton>
          </motion.div>
          <div className="mt-4 grid grid-cols-2 gap-2 sm:grid-cols-5" aria-label="Beneficios de compra" data-id="element-225" data-mp="3f93fvznk1jmy">
            {benefits.map(({
            icon: Icon,
            label
          }, index) => <div key={label} className={`flex min-h-[4.5rem] flex-col items-center justify-center rounded-xl border border-brand-violet/25 bg-brand-paper px-2 py-2 text-center ${index === benefits.length - 1 ? 'col-span-2 sm:col-span-1' : ''}`} data-id="element-226" data-mp="359ulj5os2302" data-mpi={index}>
                <Icon className="h-4 w-4 text-brand-teal" aria-hidden="true" data-id="element-227" data-mp="3szgm9xkssqa6" />
                <span className="mt-1 text-[10px] font-semibold leading-tight text-brand-text" data-id="element-228" data-mp="3o75de582xu5h">
                  {label}
                </span>
              </div>)}
          </div>
          <p className="mt-4 text-center text-xs text-brand-muted" data-id="element-229" data-mp="kk5bd5z0r5dp">
            <ShieldCheckIcon className="mr-1 inline h-3.5 w-3.5 text-brand-teal" data-id="element-230" data-mp="fsna0gt332s7" />
            Garantía de 7 días sin preguntas
          </p>
        </div>
      </Section>
    </div>;
}